import { remove } from '@utils/array'

export const SelectMixin = {
  props: {
    value: { type: [Object, Array] },
    useSelected: Boolean,
    itemKey: { type: String, default: 'id' },
    itemSelectedKey: { type: String, default: 'id' },
    multiSelect: Boolean,
  },
  data: () => ({
    selectObject: {},
  }),
  computed: {
    c_itemSelectedKey() {
      return this.itemSelectedKey || this.itemKey || 'id'
    },
  },
  created() {
    this.selectHandle = this.multiSelect
      ? new MutleSelectHandle(this.c_itemSelectedKey)
      : new SingleSelectHandle(this.c_itemSelectedKey)
  },
  watch: {
    selected(value) {
      this.selectHandle.init(value)
      this.checkData()
    },
  },
  methods: {
    checkSelect(item) {
      return this.selectHandle.checkSelect(item)
    },
    toggleSelectItem(item) {
      if (!this.useSelected) return
      this.selectHandle.toggleSelectItem(item)
      this.checkData()
    },
    checkData() {
      this.selectObject = this.selectHandle.selectObject
      let items = this.selectHandle.getValue()
      this.$emit('input', items)
    },
  },
}
export class SelectHandle {
  constructor(key) {
    this.selectObject = {}
    this.selectArray = []
    this.selectObjectData = {}
    this.itemKey = key
  }
}
export class MutleSelectHandle extends SelectHandle {
  init(selecteds) {
    if (!selecteds) {
      return
    }
    let selectObject = {}
    let selectObjectData = {}
    let selectArray = []
    if (selecteds && selecteds.length > 0) {
      selecteds.forEach((element, i) => {
        let itemKey = element[this.itemKey]
        selectObject[itemKey] = i + 1
        selectObjectData[itemKey] = element
        selectArray.push(itemKey)
      })
    }
    this.selectObject = selectObject
    this.selectObjectData = selectObjectData
    this.selectArray = selectArray
  }
  checkSelect(item) {
    let itemKey = item[this.itemKey]
    let index = this.selectObject[itemKey]
    return index >= 0 ? index + 1 : false
  }
  toggleSelectItem(item) {
    let itemKey = item[this.itemKey]
    if (this.selectArray.includes(itemKey)) {
      remove(this.selectArray, (x) => x == itemKey)
      delete this.selectObject[itemKey]
      delete this.selectObjectData[itemKey]
    } else {
      this.selectArray.push(itemKey)
      this.selectObjectData[itemKey] = item
    }
    this.resetIndex()
  }
  resetIndex() {
    let selectObject = {}
    this.selectArray.forEach((id, i) => {
      selectObject[id] = i + 1
    })
    this.selectObject = selectObject
  }
  getValue() {
    return this.selectArray.map((x) => this.selectObjectData[x])
  }
}
export class SingleSelectHandle extends SelectHandle {
  init(selected) {
    this.toggleSelectItem(selected)
  }
  checkSelect(item) {
    let itemKey = item[this.itemKey]
    let index = this.selectObject[itemKey]
    return index >= 0 ? true : false
  }
  toggleSelectItem(item) {
    if (!item || item[this.itemKey] == this.selectArray[0]) {
      this.clear()
      return
    }
    let itemKey = item[this.itemKey]
    this.selectArray = [itemKey]
    this.selectObject = { [itemKey]: 'x' }
    this.selectObjectData = { [itemKey]: item }
  }
  clear() {
    this.selectArray = []
    this.selectObject = {}
    this.selectObjectData = {}
  }
  getValue() {
    return this.selectArray.map((x) => this.selectObjectData[x])[0]
  }
}
